<template>
    <div class="h-select-tree">
        <el-dropdown 
        trigger="click" 
        placement="bottom"
        ref="dropdown"
        @visible-change="visibleChange"
        :style="{'width':width}"
        :hide-on-click="false"
        >
            <el-input
            :placeholder="placeholder"
            :suffix-icon="suffixIcon"
            :size="size"
            readonly
            clearable
            >
                <template v-for="(item,index) in valueName">
                    <template v-if="multiple">
                        <span
                            :class="'el-tag el-tag--info el-tag--light el-tag--'+size"
                            slot="prefix" 
                            :key="index"
                            v-if="(index === valueName.length-1)"
                        >
                            <span class="el-select__tags-text" :title="item.label">{{item.label}}</span>
                            <i class="el-tag__close el-icon-close" @click.stop="removeTag(item)"></i>
                        </span>
                    </template>
                    <template v-else>
                        <span :key="index" slot="prefix" class="h-only">
                            {{item.label}}
                        </span>
                    </template>
                </template>
                <span slot="prefix" v-show="multiple && valueName.length>1">+{{valueName.length}}</span>
            </el-input>
            
            <el-dropdown-menu slot="dropdown" style="padding:5px">
                <el-dropdown-item>
                    <el-input
                        v-if="filterable"
                        size="small"
                        clearable
                        placeholder="输入关键字进行过滤"
                        v-model="filterText">
                    </el-input>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-tree
                        ref="tree"
                        :data="data"
                        :props="props"
                        highlight-current
                        :expand-on-click-node="false"
                        :node-key="props.value"
                        :check-strictly="checkStrictly"
                        :show-checkbox="multiple"
                        :check-on-click-node="checkNode"
                        :default-checked-keys="defaultCheckedKeys"
                        :multiple="multiple"
                        :default-expand-all="defaultExpandAll"
                        :filter-node-method="filterNode"
                        :load="load"
                        :lazy="lazy"
                        @node-click="handleNodeClick"
                        @check="checkChangeNodes"
                        >
                    </el-tree>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    name: "h-select-tree",
    props:{
        value:{
            type:String | Number,
            default:()=>''
        },
        checkStrictly:{
            type:Boolean,
            default:()=> true
        },
        showCheckbox:{
            type:Boolean,
            default:()=> false
        },
        placeholder:{
            type:String,
            default:()=> ""
        },
        size:{
            type:String,
            default:()=> "small"
        },
        data:{
            type:Array,
            default:()=>[]
        },
        props:{
            type:Object,
            required:true,
            default:function (){
                return {
                    children: 'children',
                    label: 'label',
                    value: 'id'
                }
            }
        },
        // 配置是否可多选
        multiple: {
            type: Boolean,
            default:()=> false
        },
        // 树节点是否全部展开
        defaultExpandAll: {
            type: Boolean,
            default:()=> false
        },
        // 是否可搜索
        filterable: {
            type: Boolean,
            default:()=> false
        },
        // 懒加载树
        lazy: {
            type: Boolean,
            default:()=> false
        },
        // 输入框宽度
        width: {
            type: String,
            default:()=> '300px'
        },
    },
    data() {
        return {
            suffixIcon:"el-icon-arrow-down",
            defaultProps:{
                children: 'children',
                label: 'label'
            },
            checkNode:false,
            defaultCheckedKeys:[],
            valueName:[],
            filterText:''
        }
    },
    mounted(){
        this.$nextTick(()=>{
            if(this.multiple){
                this.checkNode = true
                this.defaultCheckedKeys = this.value.split(',')
            }else{
                this.checkNode = false
                this.$refs.tree.setCurrentKey(this.value)
            }
            this.changeName(this.value)
        })
    },
    methods: {
        load(node, resolve){
            this.$emit('load',node,resolve)
        },
        // 多选移除tag
        removeTag(tag){
            this.valueName = this.valueName.filter((item)=>{
                return item.value != tag.value
            })
            let keys = []
            this.valueName.map(v=>{
                keys.push(v.value)
            })
            this.$emit('input', keys.join(','))
            if(this.valueName.length>0){
                if(this.valueName.length === 1){
                    this.valueName.map(item=>{
                        if(!item){
                            this.valueName = [];
                        }
                    })
                }
            }
            this.$refs.tree.setCheckedKeys(keys)
        },
        // 解析v-model传入的值
        changeName(data){
            this.valueName = []
            let values = data.split(",")
            values.map(i=>{
                this.valueName.push(this.queryTree(this.data,i))
            })
            if(this.valueName.length>0){
                if(this.valueName.length === 1){
                    this.valueName.map(item=>{
                        if(!item){
                            this.valueName = [];
                        }
                    })
                }
            }
        },
        // 判断是否关闭
        visibleChange(e){
            if(e){
                this.suffixIcon = "el-icon-arrow-up";
            }else{
                this.suffixIcon = "el-icon-arrow-down"
            }
        },
        // 点击树节点事件
        handleNodeClick(node){
            if(!this.multiple){
                let obj = {
                    label:node[this.props.label],
                    value:node[this.props.value]
                }
                this.valueName = [obj]
                this.$emit('input',node[this.props.value])
                this.$emit('node-click',node)
                // this.$refs.dropdown.hide();
            }
        },
        // 多选触发事件
        checkChangeNodes(node,nodes){
            let key = []
            nodes.checkedNodes.map(v=>{
                key.push(v[this.props.value])
            })
            let value = key.join(',')
            this.$emit('input', value)
            this.$emit('check', node,nodes)
            this.changeName(value)
        },
        // json数组扁平化
        queryTree(tree, id) {
            let stark = [];
            let obj = {}
            stark = stark.concat(tree);
            while (stark.length) {
                const temp = stark.shift();
                if (temp[this.props.children]) {
                    stark = stark.concat(temp[this.props.children]);
                }
                if (temp[this.props.value] == id) {
                    obj = {
                        label:temp[this.props.label],
                        value:temp[this.props.value]
                    }
                    return obj;
                }
            }
            return;
        },
        // 搜索
        filterNode(value, data) {
            if (!value) return true;
            return data[this.props.label].indexOf(value) !== -1;
        }
    },
    watch:{
        valueName:{
            deep:true,
                handler:function(newV,oldV){
                    if(!this.multiple && newV && newV.length){
                        // this.suffixIcon = 'el-icon-circle-close'
                    }
                }
        },
        filterText(val) {
            this.$refs.tree.filter(val);
        }
    },
}
</script>

<style scoped lang="less">
::v-deep .el-dropdown-menu__item{
    height: 100%;
    width: 100%;
    padding:0 !important;
    .el-input{
        width: 100%;
        height: auto;
    }
    .el-tree{
        box-sizing: border-box;
        max-height: 274px;
        overflow-y: auto;
        padding: 5px 0;
        .el-tree-node{
            box-sizing: border-box;
        }
    }
}
/deep/.el-input__prefix{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #606266;
    flex-wrap: wrap;
    width: calc(100% - 50px);
    span{
        margin-left: 5px;
        max-width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        span{
            width: calc(100% - 20px);
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
.h-only{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* @charset "utf-8"; */
::-webkit-scrollbar {
  width: 5px;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: #fff;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: rgb(221, 222, 224);
}
</style>
